import RestaurantSettings from './RestaurantSettings';

export default RestaurantSettings;
